<template>
  <div class="home-page p-4">
    <h1>Home page</h1>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import httpClient from '../../core/services/http.service';
import ContentSpinner from '../../core/components/ContentSpinner';

export default {
  name: 'Home',
  components: {ContentSpinner},
  data: () => {
    return {};
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>

  .home-page {
    flex: 1;
    overflow: auto;
  }
</style>
